module.exports = __webpack_public_path__ + "img/kyc-check-green.28801900.svg";